import React, { useState } from "react";
import imgSexualmente from '../../imgs/saude-geral/img-6.png';
import imgBtn from '../../imgs/icon-btn.png';
import { Button, Dialog, DialogContent } from '@mui/material';
import imgModal from '../../imgs/saude-geral/img-7.png';
import { useIsMobile } from '../../hooks/useIsMobile';
import CloseIcon from '@mui/icons-material/Close';


export default function ProblemasNosDiasDeHoje() {
    const [showModal, setShowModal] = useState(false);
    const isMobile = useIsMobile();

    return (
        <div style={{ paddingTop: 60, paddingBottom: isMobile ? 60 : 120 }}>
            <h1 style={{ textAlign: 'center', fontSize: isMobile ? 22 : 28 }}>Infecções Sexualmente Transmissíveis (IST’s)</h1>

            <div className="container">
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <img
                        src={imgSexualmente}
                        alt="infecção sexualmente transmissível"
                        style={{
                            marginBottom: 40,
                            width: isMobile ? '100%' : 1100,
                            maxWidth: '100%',
                            height: 'auto',
                            borderRadius: 8,
                        }}
                    />
                </div>

                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button
                        onClick={() => setShowModal(true)}
                        className="blinking-button"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            padding: isMobile ? '10px 14px' : '14px 24px',
                            fontSize: isMobile ? 14 : 16,
                            borderRadius: 8,
                            cursor: 'pointer',
                            border: 'none',
                            backgroundColor: '#1976d2',
                            color: 'white'
                        }}
                    >
                        <img
                            src={imgBtn}
                            alt="ícone botão"
                            style={{ marginRight: 10, width: isMobile ? 30 : 50 }}
                        />
                        SAIBA MAIS SOBRE A VACINA CONTRA O HPV
                    </button>
                </div>

                <Dialog
                    fullScreen={isMobile}
                    open={showModal}
                    onClose={() => setShowModal(false)}
                >
                    <DialogContent>
                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Button>
                                <CloseIcon onClick={() => setShowModal(false)} />
                            </Button>
                        </div>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: isMobile ? 'column' : 'row',
                                alignItems: isMobile ? 'center' : 'flex-start',
                                textAlign: isMobile ? 'center' : 'left',
                                gap: 20
                            }}
                        >
                            <img
                                src={imgModal}
                                alt="HPV vacina"
                                style={{
                                    width: isMobile ? '80%' : 200,
                                    height: isMobile ? 'auto' : 200,
                                    objectFit: 'contain'
                                }}
                            />
                            <div>
                                <p>Política Nacional de Imunizações (PNI).</p>
                                <p>Vacina contra o papilomavírus humano (HPV) é fornecida pelo serviço público.</p>
                                <p><strong>O HPV pode causar diversos problemas, entre eles: o câncer.</strong></p>
                                <p>Crianças e adolescentes de 09 a 14 anos de idade (meninas e meninos).</p>
                                <p>A vacina induz maior quantidade de anticorpos e garante proteção antes do início da vida sexual.</p>
                            </div>
                        </div>
                    </DialogContent>
                </Dialog>
            </div>
        </div>
    );
}
